import { post, get, del, put } from './requests'

export const getMindfulBreaks = key =>
  get(['api', 'mindfulBreaks'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const setMindfulBreaksOrder = key => payload =>
  post(
    ['api', 'mindfulBreaks', 'order'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const deleteMindfulBreak = key => id =>
  del(['api', 'mindfulBreaks', id], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const createMindfulBreak = key => payload =>
  post(
    ['api', 'mindfulBreaks'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const updateMindfulBreak = key => (id, payload) =>
  put(
    ['api', 'mindfulBreaks', id],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const disableReminderType = key => payload =>
  post(
    ['api', 'mindfulBreaks', 'disable-reminder-type'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const toggleReminderMindfulBreak = key => id =>
  post(['api', 'mindfulBreaks', id, 'toggleReminder'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })



// WEBPACK FOOTER //
// ./src/services/mindful-breaks.js